import { AMBER, BORDER_COLOR } from '../../styles/tokens';

export default function StatCard({ label, value, subtitle, highlight, onClick, active, subtitleLarge }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: highlight ? AMBER : '#fff',
        color: highlight ? '#fff' : '#1e293b',
        border: active
          ? `2px solid ${highlight ? '#fff' : AMBER}`
          : `1px solid ${highlight ? AMBER : BORDER_COLOR}`,
        borderRadius: 12,
        padding: active ? '15px 19px' : '16px 20px',
        flex: 1,
        minWidth: 140,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.15s',
        boxShadow: highlight
          ? '0 4px 16px rgba(217,119,6,0.25)'
          : active
            ? '0 2px 8px rgba(217,119,6,0.15)'
            : '0 1px 4px rgba(0,0,0,0.05)',
      }}
    >
      <div style={{
        fontSize: 11, fontWeight: 600,
        opacity: highlight ? 0.85 : 0.55,
        marginBottom: 4,
        textTransform: 'uppercase', letterSpacing: '0.06em',
      }}>
        {label}
      </div>
      <div style={{ fontSize: 26, fontWeight: '700', lineHeight: 1.2 }}>{value}</div>
      {subtitle && (
        <div style={{
          fontSize: subtitleLarge ? 18 : 11,
          fontWeight: subtitleLarge ? '700' : undefined,
          opacity: subtitleLarge ? 0.9 : 0.65,
          marginTop: 3,
        }}>
          {subtitle}
        </div>
      )}
    </div>
  );
}
